import { System } from './../../shared-components/System';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeesAndBilling } from './fees-and-billing.model';

@Injectable()
export class FeesAndBillingService {

  constructor(private http: HttpClient) { }

  getFeesAndBilling(studentId: number, yearId: number, userId: number): Observable<FeesAndBilling[]> {
    let queryString = '';
    queryString += "?studentId=" + studentId +
        "&yearId=" + yearId +
        "&userId=" + userId;
    return this.http.get<FeesAndBilling[]>(System.apiURL.Student + 'GetFeesAndBilling' + queryString);
  }
}
